/**
 * Backend rol adları (`GET /api/users/me` → `roles[].name`). Sunucudaki hiyerarşi
 * (ADMIN > SELLER > USER) istemciye yansımaz; ADMIN'in satıcı sayılması `useIsSeller` içinde
 * elle yapılır. `ROLE_USER` taban roldür ve herkeste vardır, bu yüzden burada sabiti yok.
 */
export const ROLES = {
  ADMIN: 'ROLE_ADMIN',
  SELLER: 'ROLE_SELLER',
} as const;
